module.exports = __webpack_public_path__ + "static/media/deakin.52b4c254.jpg";